import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Stack, Typography } from '@mui/material';

const UnavailableLegend: FC = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" alignItems="center" gap="5px">
      <Box
        sx={{
          width: '18px',
          height: '16px',
          borderRadius: '6px',
          backgroundColor: (theme) => theme.palette.red[200],
        }}
      />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 1.25,
          color: (theme) => theme.palette.grey[600],
        }}
      >
        {t('unavailable')}
      </Typography>
    </Stack>
  );
};

export default UnavailableLegend;
